import React from 'react';

const QuienesSomos = () => {
  return (
    <section id="quienes-somos" className="py-16 sm:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-primary mb-12 sm:mb-16">
          Quienes somos
        </h2>

        <div className="max-w-4xl mx-auto text-center mb-16">
          <p className="text-gray-700 text-lg leading-relaxed">
            Sp Asociados es un estudio integrado por profesionales en Ciencias Económicas que tiene como objetivo brindar asesoramiento de calidad profesional.  El Estudio se dedica a trabajar en equipo de manera personalizada, enfocándose en la necesidad del cliente, asesorándolo de manera integral.
A través de nuestra experiencia y capacitación continua, nos aseguramos de brindar no solo cumplimiento normativo y legal, sino también oportunidades para el crecimiento de tu negocio.
          </p>
        </div>

        {/* Founders Names */}
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-8 sm:gap-16">
            <div>
              <p className="text-xl font-semibold mb-1" style={{ color: '#050835' }}>
                Silvia M Safranchik
              </p>
              <p className="text-base" style={{ color: '#050835' }}>
                (Contadora U.B.A.)
              </p>
            </div>
            <div>
              <p className="text-xl font-semibold mb-1" style={{ color: '#050835' }}>
                Sylvia M Peruzzo
              </p>
              <p className="text-base" style={{ color: '#050835' }}>
                (Contadora U.B.A.)
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuienesSomos;
